import { isNumber } from 'lodash';
import {
  CAMERA_PRESENTER,
  SCREEN_PRESENTER,
  CREATE_NEW_SOURCE_ID,
  SOURCE_ROLE_HOST
} from '@shoflo/polymer';
import {
  setAudioOutputDevice,
  setAudioInputDevice,
  setVideoInputDevice,
  removeDirectorAttendee,
  setDesiredAttendeeMuteStatus
} from '@shoflo/studio-redux/actions';
import {
  NO_DEVICE_FOUND,
  PERMISSION_DENIED
} from '@studio/constants/ReadinessCheck';
import createSource from './createSource';
import updateSource from './updateSource';
import { AUTO_CREATED_FOR } from 'actions/utils';
import { setProgram } from 'actions/Broadcast';
import { selectLastPresenterSource } from 'selectors/broadcastSourcesSelector';
import { setDesiredAttendeeCameraStatus } from '../attendees';

export default (settings, unassignedCameraSource, sourceDescription = '') => {
  return (dispatch, getState) => {
    const {
      videoInputDeviceId,
      audioInputDeviceId,
      audioOutputDeviceId,
      meeting: { attendeeResponse: settingsAttendeeResponse } = {}
    } = settings;

    const state = getState();
    let { order: lastCameraPresenterOrder } = selectLastPresenterSource(state);

    const {
      attendeeRoster,
      meeting: { attendeeResponse: stateAttendeeResponse },
      user,
      readinessCheck: { camera }
    } = getState();
    const cameraUnavailable =
      camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED;
    const userId = user && user._id;
    const attendeeResponse = settingsAttendeeResponse || stateAttendeeResponse;

    // set camera/mic preferences
    videoInputDeviceId && dispatch(setVideoInputDevice(videoInputDeviceId));
    audioInputDeviceId &&
      dispatch(setAudioInputDevice(audioInputDeviceId, settings));
    dispatch(setAudioOutputDevice(audioOutputDeviceId, settings));

    const { AttendeeId: attendeeId } = attendeeResponse.Attendee;

    /**
     * Using `director` here because we need to know the status of the director as setting to true will affect the logic in presenter view
     */
    dispatch(
      setDesiredAttendeeCameraStatus(
        attendeeId,
        false // this is off by default, will be turned on by middleware on successful meeting join if number of cameras is less than 10
      )
    );
    const title =
      attendeeRoster[attendeeId.replace('#content', '')]?.name ||
      `${AUTO_CREATED_FOR} ${attendeeId}`;

    const order = isNumber(lastCameraPresenterOrder)
      ? lastCameraPresenterOrder + 1
      : 0;

    if (
      unassignedCameraSource &&
      unassignedCameraSource !== CREATE_NEW_SOURCE_ID
    ) {
      //should remove the director attendee from the program
      dispatch(removeDirectorAttendee(setProgram, attendeeId));
      dispatch(
        updateSource(unassignedCameraSource, {
          value: attendeeId,
          cameraUnavailable: cameraUnavailable
        })
      );
      // remove the attendee from the meeting
      // dispatch(deleteMeetingAttendee());
    } else {
      // create video source
      dispatch(
        createSource({
          title,
          type: attendeeId.includes('#content')
            ? SCREEN_PRESENTER
            : CAMERA_PRESENTER,
          value: attendeeId,
          order,
          description: sourceDescription,
          userId,
          role: SOURCE_ROLE_HOST,
          cameraUnavailable: cameraUnavailable
        })
      );
    }
    // Mute attendee when a source is created
    dispatch(setDesiredAttendeeMuteStatus(attendeeId, true));
  };
};
